import { reactive, computed } from 'vue'

export function useSortMixin () {
  const sortInfo = reactive({
    sortKey: null,
    sortVector: null
  })

  const clearSort = () => {
    sortInfo.sortKey = null
    sortInfo.sortVector = null
  }

  const sort = (key) => {
    if (sortInfo.sortKey !== key) {
      sortInfo.sortVector = null
    }
    sortInfo.sortKey = key

    if (!sortInfo.sortVector) {
      sortInfo.sortVector = 'DESC'
    }
    sortInfo.sortVector = (sortInfo.sortVector === 'DESC') ? 'ASC' : 'DESC'
  }

  const sortString = computed(() => {
    if (!sortInfo.sortKey || !sortInfo.sortVector) return null
    return `${sortInfo.sortKey} ${sortInfo.sortVector}`
  })

  const sortClass = computed(() => {
    return (key) => {
      return {
        'sorting': (key !== sortInfo.sortKey),
        'sorting_asc': (key === sortInfo.sortKey) && (sortInfo.sortVector === 'ASC'),
        'sorting_desc': (key === sortInfo.sortKey) && (sortInfo.sortVector === 'DESC')
      }
    }
  })

  return {
    sortInfo,
    clearSort,
    sort,
    sortString,
    sortClass
  }
}
